import firebase from 'firebase';

var defaultConfig = {
  apiKey: "AIzaSyBijDLEM0Kt9ZOdDqri7G-MLloMZwLnMFo",
  authDomain: "mcs-registration.firebaseapp.com",
  databaseURL: "https://mcs-registration.firebaseio.com",
  projectId: "mcs-registration",
  storageBucket: "mcs-registration.appspot.com",
  messagingSenderId: "319728031692"
};
export const ProductionDB = firebase.initializeApp(defaultConfig);

var stageConfig = {
  apiKey: "AIzaSyBkB6XVtOLkjo3pGjkZI0b0hpfqgFuj4pw",
  authDomain: "mcs-reg-test.firebaseapp.com",
  databaseURL: "https://mcs-reg-test.firebaseio.com",
  projectId: "mcs-reg-test",
  storageBucket: "mcs-reg-test.appspot.com",
  messagingSenderId: "836695360294"
};
export const StageDB = firebase.initializeApp(stageConfig, "stage");



// WEBPACK FOOTER //
// ./src/fire.js